import { GraphQLClient } from 'graphql-request';
import { getDeviceIds, getDevices, getDeviceGroups } from '../../schema/graphql';
import { environment } from '../../../environments/environment';
import { Device, Group } from 'synapse-common-device-service';
import EnvironmentConfig from '../../../environments/EnvironmentConfig';

export class CommonDeviceDataService {
  private graphqlClient: GraphQLClient;

  constructor(private environment: EnvironmentConfig) {
    this.graphqlClient = new GraphQLClient('https://' + this.environment.commonDeviceServiceUrl + '/graphql');
  }

  setToken(token: string): void {
    this.graphqlClient.setHeader('authorization', `Bearer ${token}`);
  }

  setEndpoint(endpoint: string): void {
    this.graphqlClient.setEndpoint(endpoint);
  }

  async getDeviceIds(): Promise<Device['id'][]> {
    const data = await this.graphqlClient.request<{ getDevices: string[] }>(getDeviceIds);
    return data.getDevices;
  }

  async getDevices({ deviceIds, tenantIds }: { deviceIds?: string[]; tenantIds?: string[] }): Promise<Device[]> {
    const data = await this.graphqlClient.request<{ getDevices: Device[] }>(getDevices, { ids: deviceIds, tenantIds });
    return data.getDevices;
  }

  async getDeviceGroups(): Promise<Group[]> {
    const data = await this.graphqlClient.request<{ getGroups: Group[] }>(getDeviceGroups);
    return data.getGroups;
  }
}

export default new CommonDeviceDataService(environment);
